import { Button, Input } from 'antd';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';

import { getDate } from '~/shared/helpers/string-helpers';
import type { ButtonType, FormFieldType } from '~/shared/types/form-type';

export type PatternP2PropsType = {
  submitting: boolean;
  withScrollBars: boolean;
  textAlign: string;
  field: string;
  repliedMessage: Record<string, unknown>;
  position3: {
    formFields: FormFieldType[];
  };
  position4: {
    formFields: FormFieldType[];
  };
  position5: {
    buttons: ButtonType[];
  };
  t: (key: string, options: { ns: string[] }) => string;
  changeRepliedMessage: (status: boolean) => void;
};

export const PatternP2 = ({
  withScrollBars,
  submitting,
  repliedMessage,
  changeRepliedMessage,
  position3,
  position4,
  position5,
  t,
  field,
}: PatternP2PropsType) => {
  const getLayout = () => (
    <div className="pattern-p2">
      {position4 && (
        <div className="pattern-p2__position-block">
          {get(position4, 'formFields', []).map((item) => {
            const Field = Input;

            return (
              <div className="pattern-p2__form-field-block" key={item.name}>
                <div className="pattern-p2__label">{item.label}</div>
                {repliedMessage && (
                  <div>
                    <h2 className="login">
                      {get(repliedMessage, 'creator.firstName')}
                      <Button className="main-button extra-small invert" onClick={() => changeRepliedMessage(false)}>
                        {/* <CloseIcon /> */}
                      </Button>
                    </h2>
                    <div
                      className="text"
                      suppressHydrationWarning
                      dangerouslySetInnerHTML={{
                        __html: get(repliedMessage, 'text'),
                      }}
                    />
                    <span className="date">
                      {getDate(get(repliedMessage, 'createdAt'), 'DATE_AND_TIME')}
                      &nbsp;
                      {isNumber(get(repliedMessage, 'data.lessonSerialNumber')) && (
                        <span className="lesson-caption">
                          {`${t('text.lesson')}: ${get(repliedMessage, 'data.lessonSerialNumber')}`}
                        </span>
                      )}
                      &nbsp;
                      {isNumber(get(repliedMessage, 'data.exerciseSerialNumber')) && (
                        <span className="exercise-caption">
                          {`${t('text.exercise')}: ${get(repliedMessage, 'data.exerciseSerialNumber') + 1}`}
                        </span>
                      )}
                    </span>
                  </div>
                )}
                <Field
                  name={field ? `${field}.${item.name}` : item.name}
                  component={Input}
                  type={item.type}
                  label={item.label}
                  {...item.config}
                  validate={item.validate ? item.validate : () => null}
                />
              </div>
            );
          })}
          {get(position4, 'buttons', []).map((item, index) => (
            <Button
              key={index}
              className="extra-small invert"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {item.buttonName}
            </Button>
          ))}
          {position3 && (
            <div className="pattern-p2__position-block">
              {get(position3, 'formFields', []).map((item) => {
                const Field = Input;

                return (
                  <div className="pattern-p2__form-field-block" key={item.name}>
                    <div className="pattern-p2__label">{item.label}</div>
                    <Field
                      name={field ? `${field}.${item.name}` : item.name}
                      component={Input}
                      type={item.type}
                      label={item.label}
                      {...item.config}
                      validate={item.validate ? item.validate : () => null}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div>
      {withScrollBars ? /* <Scrollbars universal>{ */ getLayout() : /* }</Scrollbars> */ getLayout()}
      {position5 && (
        <div className="pattern-p2__position-block">
          {get(position5, 'buttons', []).map((item, index) => (
            <Button
              key={index}
              className="extra-small invert"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {item.buttonName}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
